/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState, useContext, useEffect } from "react";
import {
  Grid,
  GridColumn as Column,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Card,
  CardContent,
  CardDescription,
  cn,
} from "@repo/ui";
import { Link } from "react-router-dom";
import { UserContext } from "utils/reducers/user";
import { isOperationAllowed, showToast } from "utils/helper";
import Layout from "components/layout";
import { useGetShiftRoutes } from "utils/apis/lookups.api";
import {
  useAssignCollectionRoute,
  useCancelCollectionOrder,
  // useCreateBulkCollectionOrders,
  useGetCollectionsOrders,
} from "utils/apis/collections.api";
import FilterBar from "components/filterBar";
import { format } from "date-fns";
import { Permissions } from "utils/enums";
import { saveFilters } from "utils/actions/user";

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

const currentDate = new Date();

export default function Collections() {
  const user = useContext(UserContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [selectedState, setSelectedState] = useState<any>({});
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const [ddlInRouteTeams, setDdlInRouteTeams] = useState("");
  const [selectedRequests, setSelectedRequests] = useState<any>([]);

  const [totalRecords, setTotalRecords] = useState<any>(1);
  const [currentPage, setCurrentPage] = useState<any>(1);
  const pageSize = 25;
  const [filters, setFilters] = useState<any>(user.filters?.collections || {});

  const { data: inRouteTeams } = useGetShiftRoutes({
    cashCenterId: user?.CashCenterId,
    shift: "morning",
    operationDate: format(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { mutate: cancelCollectionOrder, isSuccess: cancelSuccess } =
    useCancelCollectionOrder();

  const {
    isSuccess: requestSuccess,
    data: requestsData,
    isPending: loadingRequests,
  } = useGetCollectionsOrders({
    pageNumber: currentPage || 1,
    pageRowCount: pageSize,
    searchCriteria: filters?.search?.id.length >= 3 ? filters?.search?.id : "",
    operationDate: format(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    cashCenterId: user.CashCenterId,
    customerId: filters?.customer?.id || "",
    sourceSPId: filters?.sourceSPId?.id || "",
  });

  // const {
  //   mutate: createBulkCollectionOrders,
  //   isSuccess: bulkCreateSuccess,
  //   isError: bulkCreateError,
  // } = useCreateBulkCollectionOrders();

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req) => ({
      itemKey: req.itemKey,
    }));

    setSelectedRequests(requestIds);
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedRequests = selections.filter(
      (req) => req.isSelected === true,
    );

    const requestIds = selectedRequests.map((req) => ({
      itemKey: req.itemKey,
    }));

    setSelectedRequests(requestIds);
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  function ShowDetailsButtonCell(props: any) {
    const { requestId, jobNo, orderId } = props.dataItem;
    return (
      <td
        className="text-center"
        {...props}
        onClick={(e: Event) => {
          e.stopPropagation();
          props.selectionChange(props.dataItem);
        }}
      >
        {isOperationAllowed(Permissions.Collection, Permissions.View) ? (
          <Link
            to="/collections-detail"
            state={{
              requestId,
              jobNo,
            }}
          >
            {orderId}
          </Link>
        ) : (
          orderId
        )}
      </td>
    );
  }

  const { mutate: assignRoute, isSuccess: assignSuccess } =
    useAssignCollectionRoute();

  const onBtnAssignRouteClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }

    if (!ddlInRouteTeams) {
      showToast("error", "Please select route to assign.");
      return;
    }

    const routeNo = ddlInRouteTeams;

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));

    const assignmentDto: any = {
      cashCenterId: user?.CashCenterId,
      operationDate: format(
        filters?.operationDate?.id || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo,
      shift: "morning",
      requests: requestsIds,
    };

    assignRoute(assignmentDto);
  };

  useEffect(() => {
    if (assignSuccess) {
      setDdlInRouteTeams("");
      setSelectedState({});
    }
  }, [assignSuccess]);

  const onBtnCancelClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to cancel.");
      return;
    }

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));

    cancelCollectionOrder(requestsIds);
  };

  useEffect(() => {
    if (requestSuccess && requestsData?.data) {
      setTotalRecords(requestsData?.totalRecords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestSuccess, requestsData?.data]);

  useEffect(() => {
    if (cancelSuccess) {
      setSelectedState({});
    }
  }, [cancelSuccess]);

  const handleChangeFilter = (value: string, key: string) => {
    setCurrentPage(1);
    let newFilters = {};
    if (!value) {
      const updatedFilter = { ...filters };
      delete updatedFilter[key];
      setFilters({
        ...updatedFilter,
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        collections: updatedFilter,
      });
      return;
    }
    if (["operationDate", "search"].includes(key)) {
      newFilters = {
        ...filters,
        [key]: {
          name: key === "operationDate" ? format(value, "PPP") : value,
          id: value,
        },
      };
    } else {
      const { sourceSPId, ...remainingFilters } = filters;

      newFilters = {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(value),
      };
    }
    setFilters(newFilters);
    saveFilters(user.dispatch, { ...user.filters, collections: newFilters });
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Collection </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <FilterBar
              handleChangeFilter={handleChangeFilter}
              onBtnCancelClicked={onBtnCancelClicked}
              isCancel={!selectedRequests.length}
              onBtnAssignRouteClicked={onBtnAssignRouteClicked}
              setFilters={setFilters}
              filters={filters}
              inRouteTeams={inRouteTeams}
              ddlInRouteTeams={ddlInRouteTeams}
              setDdlInRouteTeams={setDdlInRouteTeams}
              isSource
            />
            <div className="border-b my-3 bg-accent" />
            {loadingRequests ? (
              loadingPanel
            ) : (
              <Grid
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FIELD}
                selectable={{
                  enabled: true,
                  drag: true,
                  cell: false,
                  mode: "multiple",
                }}
                data={process(
                  requestsData?.data?.map((req: any) => ({
                    ...req,
                    [SELECTED_FIELD]: selectedState[idGetter(req)],
                  })) || [],
                  { ...dataState, skip: 0 },
                )}
                {...dataState}
                onDataStateChange={onDataStateChange}
                sortable
                filterable
                pageable
                total={totalRecords}
                pageSize={pageSize}
                skip={(currentPage - 1) * pageSize}
                onPageChange={onPageChange}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
              >
                <Column
                  field={SELECTED_FIELD}
                  filterable={false}
                  width="40px"
                  headerSelectionValue={
                    requestsData?.data?.findIndex(
                      (item: any) => !selectedState[idGetter(item)],
                    ) === -1
                  }
                  className="text-center"
                />
                <Column
                  field="orderId"
                  title="Order Id"
                  width={160}
                  cell={ShowDetailsButtonCell}
                />
                <Column field="jobNo" title="Job #" width={90} />
                <Column field="customer" title="Customer" width={190} />
                <Column field="barcode" title="Barcode" width={160} />
                <Column field="locationId" title="Location Id" width={160} />
                <Column field="source" title="Name" width={160} />
                <Column
                  field="routeNo"
                  title="Route"
                  width={140}
                  className="text-center"
                />

                <Column field="jobNature" title="Job Nature" width={110} />

                <Column
                  field="status"
                  title="Status"
                  className="text-center"
                  width={140}
                />

                <Column field="requestedBy" title="Requested By" width={140} />
                <Column
                  field="remarks"
                  title="Remarks"
                  headerClassName={cn("max-w-md w-48")}
                  className={cn("max-w-md w-48")}
                />
              </Grid>
            )}
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}

const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image" />
    <div className="k-loading-color" />
  </div>
);
